/**
 *
 * generateThenUploadProfileZip - this part was moved from old SCM and
 * must be upgraded when new Savant upload service will implemented
 *
 */

import { v4 as uuidv4 } from 'uuid'
import _extend from 'lodash/extend'
import _size from 'lodash/size'

import { authorizedEdgeFetch } from 'app/axios/edge'
import { EDGE_CONFIG_URL } from 'app/consts'
import { profilesPageMessages } from 'features/profiles/messages'

const JSZip = require('jszip')
const parseXMLString = require('xml2js').parseString

async function getProfileUploadURL(params) {
  const res = await authorizedEdgeFetch.post(
    `/profiles`,
    {
      alias: [],
      device_class: params.device_class,
      name: params.name,
      manufacturer: params.manufacturer,
      model: params.model,
      version: params.version,
      domain_id: params.domain_id,
      profile_id: params.profile_id,
      preferred: params.preferred,
      comment: 'RMS',
      extension: 'zip',
    },
    {
      baseURL: EDGE_CONFIG_URL,
    }
  )

  return res?.data?.payload?.profileUploadUrl
}

async function uploadFile(url, file) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    body: file,
  })
}

const getMetadataFromProfile = function getMetadataFromProfile(file, profiles) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = (evt) => {
      const profileContents = evt.target.result
      const resolveProfileMetaData = (err, profileJSON) => {
        const manufacturer = profileJSON.component.$.manufacturer
        const model = profileJSON.component.$.model
        const device_class = profileJSON.component.$.device_class
        const version = profileJSON.component.$.rpm_xml_version
        const findByMatchingManufacturerAndModel = (profile) =>
          profile.manufacturer === manufacturer && profile.model === model
        const latestProfile = profiles.find(findByMatchingManufacturerAndModel)
        let profile_id = null
        if (latestProfile) {
          profile_id = latestProfile.profile_id
        } else {
          profile_id = uuidv4()
        }
        const profileMetadata = {
          manufacturer,
          model,
          device_class,
          version,
          profile_id,
        }
        resolve(profileMetadata)
      }
      parseXMLString(profileContents, resolveProfileMetaData)
    }
    reader.readAsText(file)
  })
}

function readProfile(configZip, entry, profiles, formatMessage) {
  return new Promise((resolve, reject) => {
    if (entry.isFile) {
      const evaluateProfile = (file) => {
        if (!file.name.endsWith('.xml')) {
          return reject(
            new Error(
              formatMessage(profilesPageMessages.uploadProfileResolutionError)
            )
          )
        }
        const handleError = (err) => {
          console.log(`Error getting profile metadata: ${err}`)
        }
        const processProfileMetaData = (profileMetadata) => {
          if (!_size(profileMetadata)) {
            return reject(
              new Error(
                formatMessage(profilesPageMessages.uploadProfileParsingError)
              )
            )
          }
          configZip.file(file.name, file)
          return resolve(profileMetadata)
        }
        getMetadataFromProfile(file, profiles)
          .then(processProfileMetaData)
          .catch(handleError)
        return null
      }
      entry.file(evaluateProfile)
      return null
    }
    return reject(
      new Error(
        formatMessage(profilesPageMessages.uploadProfileResolutionError)
      )
    )
  })
}

function generateZip(file, profiles, formatMessage) {
  const jsZip = new JSZip()
  const archive = jsZip.folder(file.name.replace(/\.xml$/g, '.savprofile'))
  return new Promise((resolve, reject) => {
    const resolveProfileData = (profileMetadata, zipBlob) => {
      resolve({
        zipBlob,
        profileMetadata,
      })
    }

    const onZipError = function onError(err) {
      console.log(`Error uploading profile: ${err}`)
      reject(
        new Error(
          formatMessage(profilesPageMessages.uploadProfileZipError, {
            err: err.message || `${err}`,
          })
        )
      )
    }

    const processProfileMetaData = (profileMetadata) => {
      const handleResolveProfile = (zipBlob) =>
        resolveProfileData(profileMetadata, zipBlob)

      return jsZip
        .generateAsync({ type: 'blob' })
        .then(handleResolveProfile)
        .catch(onZipError)
    }

    return readProfile(archive, file, profiles, formatMessage)
      .then(processProfileMetaData)
      .catch((err) => {
        console.log(`Error uploading profile: ${err}`)
        reject(err)
      })
  })
}

export function generateThenUploadProfileZip(
  droppedFile,
  domainId,
  profiles,
  formatMessage
) {
  let metadata = {
    name: droppedFile.name.replace(/\.xml$/g, ''),
    domain_id: domainId,
    preferred: true,
  }

  const updateProfileData = async (fileData) => {
    const zipBlob = fileData.zipBlob
    const profileMetadata = fileData.profileMetadata
    metadata = _extend(metadata, profileMetadata)
    const uploadUrl = await getProfileUploadURL(metadata)
    if (uploadUrl) {
      return await uploadFile(uploadUrl, zipBlob)
    }
  }

  return generateZip(droppedFile, profiles, formatMessage)
    .then(updateProfileData)
    .catch(() => {
      throw new Error(
        formatMessage(profilesPageMessages.uploadProfileFileError)
      )
    })
}
